import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-gray-l1 app-label-micro font-bold"
}
const _hoisted_2 = {
  key: 1,
  class: "text-red app-label-micro font-medium mt-1 mb-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", _hoisted_1, _toDisplayString(_ctx.label.toUpperCase()), 1))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default", {
      invalid: _ctx.vuelidate && _ctx.vuelidate.$error
    }, () => [
      _createVNode(_component_InputText, {
        type: _ctx.type,
        modelValue: _ctx.modelValue,
        class: _normalizeClass(
          _ctx.vuelidate && {
            'p-invalid': _ctx.vuelidate.$error
          }
        ),
        "onUpdate:modelValue": _ctx.onValueChanged
      }, null, 8, ["type", "modelValue", "class", "onUpdate:modelValue"])
    ]),
    (_ctx.vuelidate && _ctx.vuelidate.$error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.vuelidate.$errors[0].$message), 1))
      : _createCommentVNode("", true)
  ]))
}